import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useNavigate } from 'react-router-dom';

// import Footer from '../../Components/shared/Footer/Footer';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
// import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import usePersistedLanguage from '../../hooks/usePersistedLanguage';
import useWindowSize from '../../hooks/useWindowSize';
import blog1 from './../../Assets/blogs/blog1.jpg';
import blog4 from './../../Assets/blogs/blog4.jpg';
import blog5 from './../../Assets/blogs/blog5.jpg';
import blog8 from './../../Assets/blogs/blog8.jpg';
import CarouselBlog from './CarouselBlog';
import { blogsDataConsulting } from './InterfacesBlogs';

function BlogsHomeConsulting() {

    const navigate=useNavigate();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    usePersistedLanguage();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes
    return (
        <>
            <div
                className='App-intro'
            >
                <NavbarConsulting />
                {/*<div style={{display:'flex',flexDirection:'column',gap:'135px',alignItems:'center',}}>

                </div>*/}
                <div
                    className='frame72HomePage'
                >
                    <div className='frame75HomePage'>
                        <div
                            className='frame76HomePage'
                            style={{cursor:'pointer'}}
                            onClick={()=>{
                                navigate('/Consultingblogs/1');
                            }}
                        >
                            <div className='frame77HomePage frame711227HomePage'>
                                <LazyLoadImage
                                    src={blog1}
                                    width={device=='desktop'?'600px':'100%'}
                                    height={'396px'}
                                    style={{borderRadius:'20px'}}
                                />
                            </div>
                            <div
                                className='frame78HomePage'

                            >
                                <div className='frame79HomePage'>
                                    <p className='frame80HomePage'>
                                        2025
                                    </p>
                                    <h4 className='titlesociete'>
                                        {i18n.t('Les Tendances actuelles du Recrutement et du Consulting')}.
                                    </h4>
                                </div>
                                <p className='frame82HomePage'>
                                    {i18n.t('Par l\'équipe HTH')}
                                </p>
                            </div>
                        </div>
                        <div className='frame83HomePage'>
                            <div className='frame84HomePage'>
                                <h5 className='frame85HomePage'>
                                    {i18n.t('Articles en Vedette')}
                                </h5>
                            </div>

                            <div
                                className='frame89HomePage'
                                onClick={()=>{
                                    navigate('/Consultingblogs/8');
                                }}
                                style={{cursor:'pointer',flexDirection:device=='desktop' ? 'column !important':'row !important'}}
                            >
                                <div
                                    className='frame90HomePage'
                                    style={{width:'auto'}}
                                >
                                    <LazyLoadImage
                                        src={blog8}
                                        width={'139px'}
                                        height={'139px'}
                                        style={{borderRadius:'10px'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'

                                >
                                    <div className='frame92HomePage'>
                                        <p
                                            className='frame93HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            2025
                                        </p>
                                        <div className='frame94HomePage'>
                                            <h6 className='blogTitles'>
                                                {i18n.t('Comment Sécuriser efficacement les Données Sensibles sur le Cloud ?')}
                                            </h6>
                                        </div>
                                        <p
                                            className='frame95HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            {i18n.t('Par l\'équipe HTH')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='frame89HomePage'
                                onClick={()=>{
                                    navigate('/Consultingblogs/5');
                                }}
                                style={{cursor:'pointer',flexDirection:device=='desktop' ? 'column !important':'row !important'}}
                            >
                                <div
                                    className='frame90HomePage'
                                    style={{width:'auto'}}
                                >
                                    <LazyLoadImage
                                        src={blog5}
                                        width={'139px'}
                                        height={'139px'}
                                        style={{borderRadius:'10px'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'

                                >
                                    <div className='frame92HomePage'>
                                        <p
                                            className='frame93HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            2025
                                        </p>
                                        <div className='frame94HomePage'>
                                            <h6 className='blogTitles'>
                                                {i18n.t('Comment Attirer les Meilleurs Talents lors du Processus de Recrutement?')}

                                            </h6>
                                        </div>
                                        <p
                                            className='frame95HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            {i18n.t('Par l\'équipe HTH')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='frame89HomePage'
                                onClick={()=>{
                                    navigate('/Consultingblogs/4');
                                }}
                                style={{cursor:'pointer',flexDirection:device=='desktop' ? 'column !important':'row !important'}}
                            >
                                <div
                                    className='frame90HomePage'
                                    style={{width:'auto'}}
                                >
                                    <LazyLoadImage
                                        src={blog4}
                                        width={'139px'}
                                        height={'139px'}
                                        style={{borderRadius:'10px'}}
                                    />
                                </div>
                                <div
                                    className='frame91HomePage'

                                >
                                    <div className='frame92HomePage'>
                                        <p
                                            className='frame93HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            2025
                                        </p>
                                        <div
                                            className='frame94HomePage'

                                        >
                                            <h6 className='blogTitles'>
                                                {i18n.t('Les Défis de la Sécurité des Systèmes d’Information dans un Monde Big Data: Protéger les Données à l’Ère de l’Explosion des Données')}
                                            </h6>
                                        </div>
                                        <p
                                            className='frame95HomePage'
                                            style={{margin:'0px'}}
                                        >
                                            {i18n.t('Par l\'équipe HTH')}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
                <CarouselBlog
                    blogsData={blogsDataConsulting}
                    pageType={'consulting'}
                />
                <FooterConsulting
                    styleProps={{background: '#005E23',
                    }}
                />
            </div>

        </>

    );

}
export default BlogsHomeConsulting;